import { Injectable} from '@angular/core';
import { ResourceAction, ResourceParams, ResourceRequestMethod, IResourceMethod } from '@ngx-resource/core';
import { RestClient } from './rest.client';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

// Import RxJs required methods
interface Registration {
    data: any;
}

interface UserDetails {
    data: any;
}

interface Diagnostics {
    data: any;
}

interface Diagnostics {
    data: any;
}

interface CodeLanguage {
    data: any;
}

interface DownloadFormInstanceId {
    data: any;
}


@Injectable()
@ResourceParams({
    url: `${environment.url.api}`,
    pathPrefix: '/api'
})
export class RegistrationService extends RestClient {
    private oAuthService;


    @ResourceAction({
        path: '/registration/step1',
        noAuth: true
    })
    getStep1: IResourceMethod<{ email: any, token: any }, Registration>;

    @ResourceAction({
        path: '/diagnostics',
        noAuth: true,
        isArray: true
    })
    getDiagnostics: IResourceMethod<{}, Diagnostics>;

    @ResourceAction({
        path: '/registration/save?email={!email}&token={!token}',
        noAuth: true,
        method: ResourceRequestMethod.Put
    })
    saveRegistration: IResourceMethod<any, any>;

    @ResourceAction({
        path: '/registration/confirmDob',
        noAuth: true,
        method: ResourceRequestMethod.Post
    })
    confirm: IResourceMethod<{ token: any, dateOfBirth: any }, Registration>;

    @ResourceAction({
        path: '/registration/confirmDobStartInstance',
        noAuth: true,
        method: ResourceRequestMethod.Post
    })
    confirmDOBStartInstance: IResourceMethod<{ token: any, dateOfBirth: any }, Observable<Response>>;

    @ResourceAction({
            path: '/registration/confirmDobDownloadFile',
            noAuth: true,
            method: ResourceRequestMethod.Post
        })
        confirmDobDownloadFile: IResourceMethod<{ token: any, dateOfBirth: any }, number>;

    @ResourceAction({
        path: '/registration/checkIsValidTokenInstance',
        noAuth: true,
        method: ResourceRequestMethod.Post
    })
    checkIsValidTokenInstance: IResourceMethod<{ token: any}, CodeLanguage>;

    @ResourceAction({
      path: '/registration/checkIsValidTokenInstanceForDownload',
      noAuth: true,
      method: ResourceRequestMethod.Post
    })
    checkIsValidTokenInstanceForDownload: IResourceMethod<{ token: any }, CodeLanguage>;

    @ResourceAction({
        path: '/cer/access',
    })
    checkCerAccess: IResourceMethod<any, any>;

    @ResourceAction({
        path: '/registration/reLogin/{:hospitalId}/{:token}',
        method: ResourceRequestMethod.Post
    })
    reLogin: IResourceMethod<{ hospitalId: any, token: any }, Observable<Response>>;

    @ResourceAction({
        path: '/registration/revokeToken/{:tokenId}',
        method: ResourceRequestMethod.Post
    })
    revokeToken: IResourceMethod<{ tokenId: any }, Observable<Response>>;
}
